const REGISTER_ERROR_MESSAGES = {
    emptyName: '学校名を入力してください。',
    emptyEmail: 'メールアドレスを入力してください。',
    invalidEmail: 'メールアドレスの形式が正しくありません。',
    password: '6文字以上で設定してください。',
    confirmationPassword: '確認用のパスワードが一致しません。\n再度入力してください。',
};
export default REGISTER_ERROR_MESSAGES;
